/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable no-empty */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import constants from './constants';

function Set_Ckie(name, value, expires, path, domain, secure) {
  try {
    const today = new Date();
    today.setTime(today.getTime());
    if (expires) {
      expires = expires * 1000 * 60 * 60 * 24;
    }
    const expires_date = new Date(today.getTime() + expires);
    document.cookie = `${name}=${escape(value)}${
      expires ? `;expires=${expires_date.toGMTString()}` : ''
    }${path ? `;path=${path}` : ''}${domain ? `;domain=${domain}` : ''}${
      secure ? ';secure' : ''
    }`;
  } catch (ex) {}
}
function Read_Ckie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cokie = cookies[i];
    while (cokie.charAt(0) == ' ') {
      cokie = cokie.substring(1, cokie.length);
    }
    if (cokie.indexOf(nameEQ) == 0) {
      return cokie.substring(nameEQ.length, cokie.length);
    }
  }
  return undefined;
}
function Del_Ckie(name, path, domain) {
  try {
    if (Read_Ckie(name)) {
      document.cookie = `${name}=${path ? `;path=${path}` : ''}${
        domain ? `;domain=${domain}` : ''
      };expires=Thu, 01-Jan-1970 00:00:01 GMT`;
    }
  } catch (ex) {}
}
const checkExpired = function checkExpired(timeStamp) {
  return new Date().getTime() > timeStamp;
};
const getLocalStorage = function getLocalStorage(key) {
  let value;
  if (key && typeof localStorage === 'object') {
    try {
      value = JSON.parse(localStorage.getItem(key));
      if (value) {
        value.isExpired = checkExpired(value.timeStamp);
        if (value.isExpired) {
          localStorage.removeItem(key);
        }
      }
    } catch (err) {
      console.warn(err);
    }
  }
  return value;
};
const setLocalStorage = function setLocalStorage(key, value) {
  if (typeof localStorage === 'object') {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (err) {
      console.warn(err);
      return false;
    }
  }
  return undefined;
};

const removeExpiryObjectFromLocalStorage = function removeExpiryObjectFromLocalStorage(
  key,
) {
  if (typeof localStorage === 'object') {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      console.warn(err);
      return false;
    }
  }
  return undefined;
};
export default {
  //public functions
  set_cookie(name, value, expires, path, domain, secure) {
    Set_Ckie(name, value, expires, path, domain, secure);
  },
  get_cookie(name) {
    return Read_Ckie(name);
  },
  del_cookie(name, path, domain) {
    Del_Ckie(name, path, domain);
  },
  check_IsSubscribed() {
    let flag = true;
    if (!this.get_cookie(constants.NUDGE_SUBSCRIBE_COOKIE)) {
      flag = true;
    } else if (
      Date.now() - this.get_cookie(constants.NUDGE_SUBSCRIBE_COOKIE) >
      2 * 24 * 60 * 60 * 1000
    ) {
      flag = true;
    } else {
      flag = false;
    }
    if (typeof localStorage !== 'undefined') {
      const currentTimestamp = new Date().getTime();
      const wdtExpiry = parseInt(
        localStorage.getItem(constants.NUDGE_SUBSCRIBE_COOKIE) || '',
        10,
      );
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(wdtExpiry) && wdtExpiry > currentTimestamp) {
        flag = false;
      }
    }
    return flag;
  },
  checkExpired(timeStamp) {
    checkExpired(timeStamp);
  },
  getLocalStorage(key) {
    getLocalStorage(key);
  },
  setLocalStorage(key, value) {
    setLocalStorage(key, value);
  },
  removeExpiryObjectFromLocalStorage(key) {
    removeExpiryObjectFromLocalStorage(key);
  },
};
